var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-button',{staticClass:"ml-2",attrs:{"variant":"twitter"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v(_vm._s(_vm.$t('label.back'))),_c('i',{staticClass:"pl-2 fa fa-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }